export type FeatureFlagType = Record<string, boolean | number | string>;

export type FeatureFlagValue = boolean | number | string;
export type FeatureFlagConfigType = Record<
  string,
  {
    key: string;
    description: string;
    defaultValue: FeatureFlagValue;
    normalizeValue: (value: FeatureFlagValue) => FeatureFlagValue;
  }
>;
// TODO: confirm these defaultValues with team
export const FEATURE_FLAG_CONFIG: FeatureFlagConfigType = {
  "cbx-wifi-integration-enabled": {
    key: "cbx-wifi-integration-enabled",
    description: "Enable or disable the CBX WiFi integration",
    defaultValue: true,
    normalizeValue: (value: FeatureFlagValue) => value,
  },
  "yardi-integration-disabled": {
    key: "yardi-integration-disabled",
    description: "Disable the Yardi integration (kill switch: hides payments/maintenance in the app)",
    defaultValue: false,
    normalizeValue: (value: FeatureFlagValue) => value,
  },
  "minimum-app-version": {
    key: "minimum-app-version",
    description: "Minimum app version",
    defaultValue: "4.3.7",
    normalizeValue: (value: FeatureFlagValue) => value,
  },
  "maintenance-ui-enabled": {
    key: "maintenance-ui-enabled",
    description: "Enable or disable the maintenance UI",
    defaultValue: true,
    normalizeValue: (value: FeatureFlagValue) => value,
  },
  "terms-and-policy-date-published": {
    key: "terms-and-policy-date-published",
    description: "Terms and policy date published",
    defaultValue: "2024-11-11",
    normalizeValue: (value: FeatureFlagValue) => value,
  },
  "notifications-ui-enabled": {
    key: "notifications-ui-enabled",
    description: "Enable or disable the notifications UI",
    defaultValue: true,
    normalizeValue: (value: FeatureFlagValue) => value,
  },
  "events-ui-enabled": {
    key: "events-ui-enabled",
    description: "Enable or disable the events UI",
    defaultValue: true,
    normalizeValue: (value: FeatureFlagValue) => value,
  },
};

export type FeatureFlagKey = keyof typeof FEATURE_FLAG_CONFIG;

export const getFeatureFlagValue = (key: string, featureFlags: FeatureFlagType) => {
  if (!FEATURE_FLAG_CONFIG[key]) {
    throw new Error(`ERROR: YOU MUST DEFINE [${key}] in default FEATURE_FLAG_CONFIG!`);
  }

  let value = FEATURE_FLAG_CONFIG[key]?.defaultValue;
  if (featureFlags && key in featureFlags && featureFlags[key] !== undefined) {
    value = featureFlags[key];
  }
  return value;
};

export interface FeatureFlagAttributes {
  id: number;
  organization_id?: number;
  property_id?: number;
  flags: FeatureFlagType;
  createdAt?: Date;
  updatedAt?: Date;
  propertyName?: string;
  organizationName?: string;
}
